import { on } from 'delegated-events'

const fn = {
  init: () => {
    on('click', '[data-paginated-list-trigger]', async (e) => {
      e.preventDefault()

      const $list = document.querySelector('[data-paginated-list]')
      const $nav = document.querySelector('[data-paginated-list-nav]')
      const $anchor = e.target.closest('a')
      $anchor.disabled = true

      const res = await fetch($anchor.href, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      })

      const data = await res.json()

      $anchor.disabled = false

      const $newNav = document.createRange().createContextualFragment(data.nav)
      $nav.parentNode.replaceChild($newNav, $nav)

      const $newList = document
        .createRange()
        .createContextualFragment(data.list)

      $list.append($newList)
    })
  },
}

export default {
  can: () => document.body.classList.contains('pagetype-podcastpage'),
  run: fn.init,
}
